import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Gallery from './pages/Gallery';
import About from './pages/About';
import Contact from './pages/Contact';
import AddProject from './pages/AddProject';
import ProjectList from './pages/ProjectList';
import Login from './pages/Login';
import PrivatePages from './pages/PrivatePages';
import { useState, createContext } from 'react';
import Dashboard from './pages/Dashboard';
import Thankyou from './pages/Thankyou';
import ImageList from './pages/ImageList';
import TestProject from './pages/TestProject';
import ScrollTopButton from './components/ScrollTopBtn';
import NotFound from './pages/NotFound';

export const AuthContext = createContext();
function App() {

  const [pAuth, setPAuth] = useState(false);

  return (
    <BrowserRouter>
      <AuthContext.Provider value={{ pAuth, setPAuth }}>
        <div className="App">
          <Navbar />
          <div className="">
            <Routes>
              <Route path="/" element={<Home />}></Route>
              {/* <Route path="/home" element={<HomeAwesome />}></Route> */}
              <Route path="/portfolio" element={<Gallery />}></Route>
              <Route path="/projects" element={<ProjectList />}></Route>
              <Route path="/aboutus" element={<About />}></Route>
              <Route path="/contact" element={<Contact />}></Route>
              <Route path="/thankyou" element={<Thankyou />}></Route>
              <Route path="/login" element={<Login />}></Route>
              <Route path="/images" element={<ImageList />}></Route>
              <Route path="/project/:id" element={<TestProject />}></Route>

              {/* Private Routes */}
              <Route element={<PrivatePages />} >
                <Route path="/add" element={<AddProject />}></Route>
                <Route path="/minganicdashboard" element={<Dashboard />}></Route>
              </Route>

              <Route path="*" element={<NotFound />}></Route>

            </Routes>

            <ScrollTopButton />
          </div>
          <Footer />
        </div>
      </AuthContext.Provider>
    </BrowserRouter >

  );
}

export default App;
